<template>
  <v-list-item
    class="list-item"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="d-flex flex-row justify-space-between list-item__content">
      <div class="d-flex flex-row align-center">
        <div>
          <v-chip
            v-if="prefix"
            :color="prefixColor"
            class="mr-3 font-weight-medium rounded"
            outlined
            small
          >
            {{ prefix }}
          </v-chip>
        </div>
        <slot />
        <!-- <span
          v-if="count"
          class="grey--text font-weight-medium ml-1"
        >
          ({{ count }}x)
        </span> -->
      </div>
      <slot name="append" />
    </div>
  </v-list-item>
</template>

<script>
export default {
  props: {
    prefix: {
      type: String,
      default: null
    },
    prefixColor: {
      type: String,
      default: null
    },
    // count: {
    //   type: Number,
    //   default: null
    // }
  }
}
</script>

<style scoped>
.list-item {
  padding: 0 0.75rem;
  min-height: auto;
}

.list-item__content {
  padding: 1rem 0;
  width: 100%;
  border-bottom: 1px solid var(--v-stroke-lighten1);
}
</style>
